/**
 * Remodelling Library Tab - JavaScript
 * Handles tab switching and product image slider initialization
 */

(function () {
    'use strict';

    /**
     * Initialize tab functionality for a section
     */
    function initializeTabs(section) {
        const buttons = section.querySelectorAll('.tab-link');
        const tabContents = section.querySelectorAll('.tabContent');
        let activeIndex = 0;

        // Tab click handler
        buttons.forEach((button, index) => {
            button.addEventListener('click', function () {
                if (this.classList.contains('active')) return;

                // Remove active state from previous tab
                if (buttons[activeIndex]) {
                    buttons[activeIndex].classList.remove('active');
                    tabContents[activeIndex].classList.remove('show');
                }

                // Add active state to clicked tab
                this.classList.add('active');
                tabContents[index].classList.add('show');
                activeIndex = index;

                // Reinitialize sliders in the active tab
                const sliders = tabContents[index].querySelectorAll('.slider');
                sliders.forEach(slider => {
                    if (slider.classList.contains('slick-initialized')) {
                        $(slider).slick('setPosition');
                    }
                });
            });
        });
    }

    /**
     * Initialize Slick sliders
     */
    function initializeSliders(section) {
        const sliders = section.querySelectorAll('.slider');

        sliders.forEach(slider => {
            if (!slider.classList.contains('slick-initialized')) {
                $(slider).slick({
                    dots: false,
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    lazyLoad: 'ondemand'
                });
            }
        });
    }

    /**
     * Initialize all remodelling library sections
     */
    function init() {
        const sections = document.querySelectorAll('.remodeling_tab_section');

        sections.forEach(section => {
            initializeTabs(section);
            initializeSliders(section);
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Reinitialize on Shopify section load (for theme editor)
    document.addEventListener('shopify:section:load', function (event) {
        const section = event.target.querySelector('.remodeling_tab_section');
        if (section) {
            initializeTabs(section);
            initializeSliders(section);
        }
    });

})();
